import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { withFatalCheck } from '../error/withFatalCheck'
import { ProductMetaInfo, Key } from './productMetaInfo'
import * as st from './productMetaInfo.module.scss'

const VISIBLE_ITEMS_ATF = 40
const movieAtfKeys = [
  Key.Directors,
  Key.Starring,
  Key.Genres,
  Key.Subtitles,
  Key.AudioTracks
]

const tvAtfKeys = [
  Key.Starring,
  Key.Genres,
  Key.Subtitles,
  Key.AudioTracks
]

const getFields = (isTV: boolean) => {
  return isTV ? tvAtfKeys : movieAtfKeys
}

export interface IATFProductMetaInfoProps
  extends WpsRuntime.atv.wps.DetailFragmentModelProps {
  isTV: boolean
}
const AtfProductMetaInfoValid: React.ComponentType<IATFProductMetaInfoProps> = (
  props: IATFProductMetaInfoProps
) => (
  <div className={`${st.atfInfo} dv-dp-node-meta-info avu-full-width`} >
    <ProductMetaInfo
      {...props}
      fields={getFields(props.isTV)}
      expandedItemsCount={VISIBLE_ITEMS_ATF}
      id="meta-info"
    />
  </div>
)

export const AtfProductMetaInfo = withFatalCheck(AtfProductMetaInfoValid)
